._label_1ssxh_1 {
  display: flex;
  align-items: center; }
  ._label_1ssxh_1 svg {
    height: 24px;
    width: 24px; }
  ._label_1ssxh_1 ._text_1ssxh_7 {
    margin-left: 6px; }
